export enum RuntimeScheduleType {
  Daily = 1,
  WorkDays = 1 << 1,
  Weekends = 1 << 2,
  Monday = 1 << 3,
  Tuesday = 1 << 4,
  Wednesday = 1 << 5,
  Thursday = 1 << 6,
  Friday = 1 << 7,
  Saturday = 1 << 8,
  Sunday = 1 << 9,
}

export const RuntimeScheduleTypeLabels: Record<RuntimeScheduleType, string> = {
  [RuntimeScheduleType.Daily]: "Daily",
  [RuntimeScheduleType.WorkDays]: "Workdays",
  [RuntimeScheduleType.Weekends]: "Weekends",
  [RuntimeScheduleType.Monday]: "Monday",
  [RuntimeScheduleType.Tuesday]: "Tuesday",
  [RuntimeScheduleType.Wednesday]: "Wednesday",
  [RuntimeScheduleType.Thursday]: "Thursday",
  [RuntimeScheduleType.Friday]: "Friday",
  [RuntimeScheduleType.Saturday]: "Saturday",
  [RuntimeScheduleType.Sunday]: "Sunday",
};

